// extracted by mini-css-extract-plugin
export var bounce = "_ol-1";
export var generatingText = "_ol-6";
export var lightning = "_ol-4";
export var popup = "_ol-5";
export var progressBar = "_ol-7";
export var progressFill = "_ol-8";
export var progressShimmer = "_ol-9";
export var progressText = "_ol-a";
export var shimmer = "_ol-3";
export var uploadIcon = "_ol-0";
export var uploadingText = "_ol-2";